import { useMutation } from '@tanstack/react-query';
import {
  updateGatewayConversionSettings,
  UpdateGatewayConversionSettingsParams,
} from 'config/requests/orderConversion';

export function useUpdateGatewayConversionSettings() {
  const mutation = useMutation({
    mutationFn: ({ id, data }: { id: number; data: UpdateGatewayConversionSettingsParams }) =>
      updateGatewayConversionSettings(id, data),
  });

  return { updateGatewayConversionSettings: mutation };
}
